import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import AppLayout from "@/components/layout/AppLayout";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import SocialCallback from "@/pages/SocialCallback";
import CartIntentPage from "@/pages/CartIntentPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import LegacyChangePasswordPage from "@/pages/LegacyChangePasswordPage";
import CursoInscricaoPublicPage from "@/pages/CursoInscricaoPublicPage";
import CursoAvaliacaoPublicPage from "@/pages/CursoAvaliacaoPublicPage";
import CursoAvaliacaoFormadorPublicPage from "@/pages/CursoAvaliacaoFormadorPublicPage";
import CoachCasalSharePublic from "@/pages/CoachCasalSharePublic";
import DashboardPage from "@/pages/DashboardPage";
import AlertsPage from "@/pages/AlertsPage";
import LeadsPage from "@/pages/LeadsPage";
import NewLeadPage from "@/pages/NewLeadPage";
import LeadSearchPage from "@/pages/LeadSearchPage";
import LeadAnalysisPage from "@/pages/LeadAnalysisPage";
import DealsPage from "@/pages/DealsPage";
import DealDetailPage from "@/pages/DealDetailPage";
import OrdersPage from "@/pages/OrdersPage";
import OrderDetailPage from "@/pages/OrderDetailPage";
import CommissionsPage from "@/pages/CommissionsPage";
import CommissionDetailPage from "@/pages/CommissionDetailPage";
import OpportunitiesPage from "@/pages/OpportunitiesPage";
import NetworkPage from "@/pages/NetworkPage";
import RedeSaldosPage from "@/pages/RedeSaldosPage";
import ClienteValesPage from "@/pages/ClienteValesPage";
import TreePage from "@/pages/TreePage";
import IndicatorsPage from "@/pages/IndicatorsPage";
import IncentivosPage from "@/pages/IncentivosPage";
import ComparativesPage from "@/pages/ComparativesPage";
import ContactsPage from "@/pages/ContactsPage";
import ContactDetailPage from "@/pages/ContactDetailPage";
import SearchPage from "@/pages/SearchPage";
import ConfigPage from "@/pages/ConfigPage";
import CompaniesPage from "@/pages/CompaniesPage";
import ProfilePage from "@/pages/ProfilePage";
import ClienteFichaRedirect from "@/pages/ClienteFichaRedirect";
import EmailConfigPage from "@/pages/EmailConfigPage";
import NotificationsPage from "@/pages/NotificationsPage";
import ProjectionPage from "@/pages/ProjectionPage";
import LeadKanbanPage from "@/pages/LeadKanbanPage";
import LeadFocoPage from "@/pages/LeadFocoPage";
import ConsultantToolsPage from "@/pages/ConsultantToolsPage";
import BackofficePage from "@/pages/BackofficePage";
import NewOrderPage from "@/pages/NewOrderPage";
import NewOrderCartPage from "@/pages/newOrder/NewOrderCartPage";
import NewOrderCheckoutPage from "@/pages/newOrder/NewOrderCheckoutPage";
import NewOrderPaymentPage from "@/pages/newOrder/NewOrderPaymentPage";
import ObjectivesPage from "@/pages/ObjectivesPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import DownlinePendingOrdersPage from "@/pages/DownlinePendingOrdersPage";
import CRMPropostasListPage from "@/crm/pages/CRMPropostasListPage";
import { CRMCursosInscricoesListPage, CRMCursoInscricoesDetailPage } from "@/crm/pages/CRMCursosInscricoesPage";
import CRMPropostaWizardPage from "@/crm/pages/CRMPropostaWizardPage";
import AreaSelectorPage from "@/pages/AreaSelectorPage";
import MediaApp from "@/media/MediaApp";
import CookieConsent from "@/components/CookieConsent";
import MyApp from "@/my/MyApp";
import MyShop from "@/my/pages/MyShop";
import PublicShopLayout from "@/my/components/PublicShopLayout";
import AdminApp from "@/admin/AdminApp";
import DreamsApp from "@/dreams/DreamsApp";
import RouteTitle from "@/components/RouteTitle";

function App() {
  // Hostname-based redirect (executa ANTES do React Router para garantir
  // que utilizadores nos subdomínios não são apanhados pelo auth-guard
  // do AppLayout). Apenas reescreve o pathname inicial.
  // Opt-out: query param `?crm=1` força permanência em `/` (usado pelo
  // AppSwitcher quando o utilizador clica explicitamente em "CRM").
  if (typeof window !== "undefined" && window.location.pathname === "/") {
    const params = new URLSearchParams(window.location.search);
    const forceCrm = params.get("crm") === "1";
    if (!forceCrm) {
      const host = window.location.hostname.toLowerCase();
      const HOSTNAME_ROUTES = {
        "my.ihavethepower.net": "/my",
        "admin.ihavethepower.net": "/admin",
        "dreams.ihavethepower.net": "/dreams",
        "media.ihavethepower.net": "/media",
        "crm.ihavethepower.net": "/",
      };
      if (HOSTNAME_ROUTES[host]) {
        window.history.replaceState(null, "", HOSTNAME_ROUTES[host]);
      }
    }
  }
  return (
    <AuthProvider>
      <BrowserRouter>
        <RouteTitle />
        <Routes>
          <Route path="/media/*" element={<MediaApp />} />
          <Route path="/my/loja" element={<Navigate to="/loja" replace />} />
          <Route path="/my/loja/:slug" element={<Navigate to="/loja" replace />} />
          <Route path="/my/*" element={<MyApp />} />
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="/dreams/*" element={<DreamsApp />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/auth/social-callback" element={<SocialCallback />} />
          <Route path="/cart/intent" element={<CartIntentPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          {/* Compat: emails legacy do api.ihavethepower.net com URL
              /account/changePassword?id=<hash-bcrypt-mangled> */}
          <Route path="/account/changePassword" element={<LegacyChangePasswordPage />} />
          <Route path="/cursos/inscricao/:token" element={<CursoInscricaoPublicPage />} />
          <Route path="/cursos/avaliacao/:token" element={<CursoAvaliacaoPublicPage />} />
          <Route path="/cursos/avaliacao-formador/:token" element={<CursoAvaliacaoFormadorPublicPage />} />
          <Route path="/coach/casal/share/:token" element={<CoachCasalSharePublic />} />
          <Route path="/areas" element={<AreaSelectorPage />} />
          {/* Loja pública (sem login obrigatório) */}
          <Route element={<PublicShopLayout />}>
            <Route path="/loja" element={<MyShop />} />
            <Route path="/loja/:slug" element={<MyShop />} />
          </Route>
          <Route element={<AppLayout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/alertas" element={<AlertsPage />} />
            <Route path="/leads" element={<LeadsPage />} />
            <Route path="/leads/nova" element={<NewLeadPage />} />
            <Route path="/leads/pesquisa" element={<LeadSearchPage />} />
            <Route path="/leads/analise" element={<LeadAnalysisPage />} />
            <Route path="/negocios" element={<DealsPage />} />
            <Route path="/negocios/:id" element={<DealDetailPage />} />
            <Route path="/encomendas" element={<OrdersPage />} />
            <Route path="/encomendas/rede-pendentes" element={<DownlinePendingOrdersPage />} />
            <Route path="/encomendas/nova" element={<Navigate to="/encomendas/nova/carrinho" replace />} />
            <Route path="/encomendas/nova/carrinho" element={<NewOrderCartPage />} />
            <Route path="/encomendas/nova/checkout" element={<NewOrderCheckoutPage />} />
            <Route path="/encomendas/nova/pagamento" element={<NewOrderPaymentPage />} />
            <Route path="/encomendas/nova-classico" element={<NewOrderPage />} />
            <Route path="/encomendas/:id" element={<OrderDetailPage />} />
            <Route path="/contactos" element={<ContactsPage />} />
            <Route path="/contactos/:id" element={<ContactDetailPage />} />
            <Route path="/comissoes" element={<CommissionsPage />} />
            <Route path="/comissoes/:ano/:mes" element={<CommissionDetailPage />} />
            <Route path="/oportunidades" element={<OpportunitiesPage />} />
            <Route path="/rede" element={<NetworkPage />} />
            <Route path="/rede/saldos" element={<RedeSaldosPage />} />
            <Route path="/cliente/:id/vales" element={<ClienteValesPage />} />
            <Route path="/rede/arvore" element={<TreePage />} />
            <Route path="/indicadores" element={<IndicatorsPage />} />
            <Route path="/incentivos" element={<IncentivosPage />} />
            <Route path="/comparativos" element={<ComparativesPage />} />
            <Route path="/pesquisa" element={<SearchPage />} />
            <Route path="/empresas" element={<CompaniesPage />} />
            <Route path="/config" element={<ConfigPage />} />
            <Route path="/perfil" element={<ProfilePage />} />
            <Route path="/ver-cliente/:id" element={<ClienteFichaRedirect />} />
            <Route path="/perfil/email-config" element={<EmailConfigPage />} />
            <Route path="/notificacoes" element={<NotificationsPage />} />
            <Route path="/projecao" element={<ProjectionPage />} />
            <Route path="/leads/tratar" element={<LeadKanbanPage />} />
            <Route path="/leads/foco" element={<LeadFocoPage />} />
            <Route path="/ferramentas" element={<ConsultantToolsPage />} />
            <Route path="/backoffice" element={<BackofficePage />} />
            <Route path="/objetivos" element={<ObjectivesPage />} />
            <Route path="/backoffice/analytics" element={<AnalyticsPage />} />
            <Route path="/propostas" element={<CRMPropostasListPage />} />
            <Route path="/propostas/nova" element={<CRMPropostaWizardPage />} />
            <Route path="/propostas/:id" element={<CRMPropostaWizardPage />} />
            <Route path="/cursos/inscricoes" element={<CRMCursosInscricoesListPage />} />
            <Route path="/cursos/inscricoes/:cursoId" element={<CRMCursoInscricoesDetailPage />} />
          </Route>
        </Routes>
        <CookieConsent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
